// Zwei-Klick-Löschen (Handoff §5): erster Klick färbt den Mülleimer rot und zeigt die Rückfrage aus dem
// Code als Blase darüber (statt window.confirm), zweiter Klick löscht. Nach 4 s ohne Bestätigung zurück.
import { useEffect, useState } from 'react';
import { Trash } from '@phosphor-icons/react';
import { FEHLER, KNOPF } from './form-stil';

export const BESTAETIGEN_MS = 4000;

export function FormLoeschKnopf({ frage, tip, onLoeschen, gesperrt }: {
  /** Rückfrage aus dem Code, z. B. „Vorlage „X“ wirklich löschen?“ */
  frage: string;
  /** Tooltip/Screenreader-Text des Mülleimers (aus dem Code) */
  tip: string;
  onLoeschen: () => void;
  gesperrt?: boolean;
}) {
  const [fragt, setFragt] = useState(false);
  useEffect(() => {
    if (!fragt) return;
    const t = setTimeout(() => setFragt(false), BESTAETIGEN_MS);
    return () => clearTimeout(t);
  }, [fragt]);
  return (
    <span className="relative flex shrink-0">
      {fragt && (
        // Außen positionieren, innen animieren – sonst überschreibt die Animation das translateX.
        <span className="absolute" style={{ bottom: 'calc(100% + 10px)', left: '50%', transform: 'translateX(-50%)', width: 'max-content', maxWidth: 240 }}>
          <span role="alert" className="pf-drop block" style={{
            padding: '8px 12px', borderRadius: 12, fontSize: 12.5, fontWeight: 700, lineHeight: 1.35, textAlign: 'center',
            color: FEHLER.text, background: FEHLER.blase, boxShadow: `${FEHLER.ring}, 0 10px 24px -8px rgba(0,0,0,0.6)`,
          }}>
            {frage}
          </span>
        </span>
      )}
      <button type="button" disabled={gesperrt} aria-label={fragt ? frage : tip} data-tip={fragt ? undefined : tip}
        onClick={() => { if (fragt) { setFragt(false); onLoeschen(); } else setFragt(true); }}
        onBlur={() => setFragt(false)}
        className="pf-knopf flex shrink-0 items-center justify-center border-none"
        style={{
          width: KNOPF.hoehe, height: KNOPF.hoehe, borderRadius: KNOPF.radius,
          cursor: gesperrt ? 'not-allowed' : 'pointer', opacity: gesperrt ? 0.5 : 1,
          background: fragt ? KNOPF.gefahr.flaeche : 'rgba(255,95,87,0.12)', color: fragt ? KNOPF.gefahr.text : '#ff7b72',
          boxShadow: fragt ? KNOPF.gefahr.schatten : 'none',
        }}>
        <Trash aria-hidden size={16} weight="bold" />
      </button>
    </span>
  );
}
